import {AUTH_FAIL, AUTH_LOGOUT, AUTH_START, AUTH_SUCCESS, SET_AUTH_REDIRECT_PATH} from "../actions/actionTypes";
import {updateObject} from "../common/Util";
import jwt from "jwt-decode";
import * as config from "../config";





const initialState = () => {
    const at = localStorage.getItem('accessToken');

    if (at && at == "mock") {
        return {
            type: AUTH_SUCCESS,
                id: 'mock',
            userId: 99999,
            error: null,
            name: `Lukatec Feira`,
            firstName: 'lukatec',
            email: 'lukatec@lukatec.com.br',
            defaultTenant: 0,
            expiresIn: '9999999999999',
            lastName: 'demo',
            username: 'lukatec.offline',
            permissions: [],
            frontEndPermissions: [2,1000,1100,1101,1102,1103,1104,1200,1300,1400,1401,1402,1500,1600,1700,1800,1900,1901,1902,1903,2000,2100,2101,2102,2103,2200,2104,2300,2301 ]

        }
    }

    if (at && at.length > 10) {
        const user = jwt(at);
        localStorage.setItem('tenantFolder', user.defaultTenant);

        return {
            id: at,
            userId: user.id,
            error: null,
            name: user.name || user.username,
            firstName: user.firstName,
            middleName: (user.middleName != null)? user.middleName : '',
            email: user.email,
            expiresIn: user.exp,
            defaultTenant: user.defaultTenant,
            lastName: user.lastName,
            username: user.username,
            permissions: user.permissions,
            frontEndPermissions: user.frontEndPermissions,
            loading : false,
            authRedirectPath: '/',
            jwt:at
        }
    }

    return {
        id: null,
        userId: null,
        firstName: null,
        lastName: null,
        username: '',
        middleName: '',
        name: null,
        defaultTenant: null,
        error: null,
        expiresIn: null,
        frontEndPermissions: [],
        permissions: [],
        loading: false,
        authRedirectPath: '/',
        jwt: ''
    }
};

const authStart = ( state, action ) => {
    return updateObject( state, { error: null, loading: true } );
};

const authSuccess = (state, action) => {

    console.log('authSucess state', state);
    console.log('authSucess action', action);

    const { id, userId, firstName, lastName, defaultTenant } = action;
    localStorage.setItem('accessToken', id);


    if (userId !== localStorage.getItem('userId')) {
        localStorage.setItem('userId', userId);
        localStorage.setItem('estabId','1');
        localStorage.setItem('tenantFolder', defaultTenant);
    }


    return updateObject( state, {
        id: action.id,
        userId: action.userId,
        name: action.name || action.username,
        firstName: firstName,
        lastName: lastName,
        username: action.username,
        middleName: action.middleName? action.middleName : '',
        error: null,
        loading: false,
        defaultTenant: action.defaultTenant,
        permissions: action.permissions,
        frontEndPermissions: action.frontEndPermissions,
        expiresIn: action.expiresIn,
        jwt: id
    } );
};

const authFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
};

const authLogout = (state, action) => {
    localStorage.removeItem('accessToken');

    return updateObject(state, initialState());
};

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, { authRedirectPath: action.path })
}


const AuthReducer = ( state = initialState(), action ) => {
    switch ( action.type ) {
        case AUTH_START: return authStart(state, action);
        case AUTH_SUCCESS: return authSuccess(state, action);
        case AUTH_FAIL: return authFail(state, action);
        case AUTH_LOGOUT: return authLogout(state, action);
        case SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state,action);
        default:
            return state;
    }
}

export default AuthReducer;
